import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface FabButton {
  id: string,
  icon: string,
  text: string,
  tooltip: string
}

@Injectable({
  providedIn: 'root'
})
export class FloatingPanelService {

  constructor() { }

  private tabList = [];

  listOfTabs: Subject<any> = new Subject<any>();
  listOfTabsChanged$ = this.listOfTabs.asObservable();

  pushNewTab(id: string, title: string){
    var result = "";
    if (this.tabList.length > 2){
      result = "error: more than 3";
    }
    else{
      if (!this.tabList.find(x => x.id == id)){
        this.tabList.push({id: id, title: title});
      }
      result = "success";
    }
    this.listOfTabs.next(this.tabList);
  }

  removeTab(id: string){
    if (this.tabList.find(x => x.id == id)){
      this.tabList.splice(this.tabList.findIndex(x => x.id == id), 1);
      this.listOfTabs.next(this.tabList);
    }
  }
}
